import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';

const AdminQuickActions = () => {
  const { isAdmin } = useAuth();
  const [signupCount, setSignupCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isDismissing, setIsDismissing] = useState(false);

  const fetchSignupCount = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "signups"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      setSignupCount(querySnapshot.size);
    } catch (error) {
      console.error('Error fetching signups:', error);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (isAdmin) {
      fetchSignupCount();
    }
  }, [isAdmin]);

  const handleDismiss = () => {
    setIsDismissing(true);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsDismissed(true);
    }, 300);
  };

  if (!isAdmin || isDismissed) return null;

  return (
    <div className={`admin-quick-actions ${isDismissing ? 'dismissing' : ''}`}>
      <div className="admin-quick-header">
        <h4>Admin Quick Actions</h4>
        <div className="admin-header-right">
          <span className="admin-badge">ADMIN</span>
          <button 
            className="dismiss-btn"
            onClick={handleDismiss}
            title="Dismiss"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>
      
      <div className="admin-quick-stats">
        <div className="quick-stat">
          <div className="stat-icon">
            <i className="fas fa-users"></i>
          </div>
          <div className="stat-content">
            <span className="stat-label">Total Signups</span>
            <span className="stat-value">
              {loading ? '...' : signupCount}
            </span>
          </div>
        </div>
        
        <div className="quick-stat">
          <div className="stat-icon">
            <i className="fas fa-eye"></i>
          </div>
          <div className="stat-content">
            <span className="stat-label">Page Views</span>
            <span className="stat-value">Today</span>
          </div>
        </div>
      </div>

      <div className="admin-quick-buttons">
        <button 
          className="quick-btn primary"
          onClick={() => window.open('/admin', '_blank')}
        >
          <i className="fas fa-tachometer-alt"></i>
          Full Dashboard
        </button>
        
        <button 
          className="quick-btn secondary"
          onClick={fetchSignupCount}
          disabled={loading}
        >
          <i className="fas fa-sync-alt"></i>
          Refresh Data
        </button>
      </div>
    </div>
  );
};

export default AdminQuickActions;
